module.exports = __webpack_public_path__ + "assets/img/extra-point.b2f95358.png";